import React, { useState } from "react";
import PortalModal from "../../Portals";
import FontPicker from "font-picker-react";
import {
  ContentEditStyle,
  ContentTitleStyle,
  ContentCards,
  ContentSaveButton,
  ContentSelect,
  OptionWrapper,
  ColorPickerBackgorund,
} from "./StyleQuestion.styled";

const StyleQuestion = ({
  setshowStyleEdit,
  stateObject,
  setstateObject,
  hideAnswerStyle = false,
}) => {
  const [clicked, setclicked] = useState(false);
  const [objCopy, setObjCopy] = useState(
    JSON.parse(JSON.stringify(stateObject))
  );
  const [questionFontFamily, setquestionFontFamily] = useState(
    objCopy.question.fontFamily == ""
      ? "Open Sans"
      : objCopy.question.fontFamily
  );
  const [answerFontFamily, setanswerFontFamily] = useState(
    objCopy.answer.fontFamily == "" ? "Open Sans" : objCopy.answer.fontFamily
  );

  const assignStyleBackground = (e) => {
    objCopy.background = e.target.value;
  };

  const assignData = (e, opc) => {
    e.preventDefault();
    let allObjCopy = { ...objCopy };
    allObjCopy[opc][e.target.name] =
      allObjCopy[opc][e.target.name] === e.target.value ? "" : e.target.value;
    setObjCopy(allObjCopy);
    setclicked(!clicked);
  };

  const saveConfiguration = () => {
    objCopy.question.fontFamily = questionFontFamily;
    objCopy.answer.fontFamily = answerFontFamily;
    objCopy.question.fontSize = objCopy.question.fontSize.includes("px")
      ? objCopy.question.fontSize
      : objCopy.question.fontSize + "px";
    objCopy.answer.fontSize = objCopy.answer.fontSize.includes("px")
      ? objCopy.answer.fontSize
      : objCopy.answer.fontSize + "px";
    setstateObject(objCopy);
    setshowStyleEdit(false);
  };

  const handleCheck = () => {
    let allObjCopy = { ...objCopy };
    allObjCopy.customStyle = !objCopy.customStyle;
    setObjCopy(allObjCopy);
    setclicked(!clicked);
  };

  const DataQuestionsAnswersStyle = (opc) => {
    return (
      <div className="grid-item">
        <p>{opc}</p>
        <FontPicker
          pickerId={opc}
          apiKey={process.env.GOOGLE_API_KEY}
          activeFontFamily={
            opc === "question" ? questionFontFamily : answerFontFamily
          }
          limit={100}
          // onChange={(event) => assignDataFont(event.family,opc) } />
          onChange={(event) =>
            opc === "question"
              ? setquestionFontFamily(event.family)
              : setanswerFontFamily(event.family)
          }
        />
        <input
          type="number"
          placeholder="Size"
          className=""
          name="fontSize"
          min={16}
          max={56}
          onChange={(e) => assignData(e, opc)}
          defaultValue={stateObject[opc].fontSize.substr(
            0,
            stateObject[opc].fontSize.length - 2
          )}
        />

        <ContentSelect>
          <button
            name="fontWeight"
            value="bold"
            style={{
              fontWeight: "bold",
              background: objCopy[opc].fontWeight == "" ? "white" : "#c5c5c5ba",
            }}
            onClick={(e) => assignData(e, opc)}
          >
            N
          </button>
          <button
            name="fontStyle"
            value="italic"
            style={{
              fontStyle: "italic",
              background: objCopy[opc].fontStyle == "" ? "white" : "#c5c5c5ba",
            }}
            onClick={(e) => assignData(e, opc)}
          >
            K
          </button>
          <button
            name="textDecoration"
            value="underline"
            style={{
              textDecoration: "underline",
              background:
                objCopy[opc].textDecoration == "underline"
                  ? "#c5c5c5ba"
                  : "white",
            }}
            onClick={(e) => assignData(e, opc)}
          >
            S
          </button>
          <button
            name="textDecoration"
            value="line-through"
            style={{
              textDecoration: "line-through",
              background:
                objCopy[opc].textDecoration == "line-through"
                  ? "#c5c5c5ba"
                  : "white",
            }}
            onClick={(e) => assignData(e, opc)}
          >
            ab
          </button>
          <input
            type="color"
            name="color"
            className="colorPicker"
            defaultValue={stateObject[opc].color}
            onChange={(e) => assignData(e, opc)}
          />
        </ContentSelect>
      </div>
    );
  };

  return (
    <div>
      <PortalModal>
        <ContentEditStyle>
          <ContentTitleStyle>
            <p>Edit Style</p>
            <p onClick={() => setshowStyleEdit(false)}>X</p>
          </ContentTitleStyle>
          <ContentCards>
            {DataQuestionsAnswersStyle("question")}
            {!hideAnswerStyle && DataQuestionsAnswersStyle("answer")}
            <div className="grid-item">
              <p>Background</p>
              <ColorPickerBackgorund
                type="color"
                defaultValue={stateObject.background}
                onChange={(event) => assignStyleBackground(event)}
              />
            </div>
          </ContentCards>
          <ContentSaveButton>
            <OptionWrapper editable={true}>
              <input
                type="checkbox"
                onClick={handleCheck}
                defaultChecked={objCopy.customStyle}
              />{" "}
              <label>Use style</label>
            </OptionWrapper>
            <button onClick={() => saveConfiguration()}>Save</button>
          </ContentSaveButton>
        </ContentEditStyle>
      </PortalModal>
    </div>
  );
};

export default StyleQuestion;
